var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import config from '@/config';
import api from '@/shared/api';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export var useCreateAcccessToken = function () {
    var intl = useIntl();
    var _a = useMutation(function (values) {
        return api.base
            .post("".concat(config.appUrls.identity, "/api/profile/pats"), __assign(__assign({}, values), { expires: parseInt(((new Date(values.expires).getTime() - new Date().getTime()) / 1000).toFixed()) }))
            .then(function (res) { return res.data; });
    }, {
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading, error = _a.error;
    return {
        createAccessToken: mutateAsync,
        isLoading: isLoading,
        error: error,
    };
};
